// extracted by mini-css-extract-plugin
module.exports = {"cGatsbyBackground":"r_b","lHeader":"r_bv","lHeader__inner":"r_bw","lHeader__left":"r_bx","lHeader__right":"r_by","lHeader__logo":"r_bz","animationMarquee":"r_d"};